/**
 * Single source of truth for the current Terms of Use / Privacy Policy version.
 * Bump this string when the terms materially change to force users to re-accept.
 */
export const CURRENT_TERMS_VERSION = "2026-06-30";
